import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Btn, Table } from "@/admin/AdminLayout";

const day = (s?: string) => (s ? new Date(s).toLocaleDateString("en-AU") : "—");

function Row({ r, onDone }: { r: any; onDone: () => void }) {
  const [to, setTo] = useState("");
  const fix = async () => {
    try { await api.post("/admin-x/redirects", { from_path: r.path, to_path: to, code: 301 }); toast(`${r.path} now goes to ${to}`); onDone(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const dismiss = async () => { await api.delete(`/admin-x/seo/not-found/${r.id}`); onDone(); };
  const refs = Array.from(new Set<string>(r.referrers || [])).filter(Boolean).slice(-2);
  return (
    <tr data-testid={`broken-row-${r.id}`}>
      <td className="px-4 py-3 font-mono text-xs break-all">{r.path}{refs.map((x) => <div key={x} className="font-sans text-[11px] text-neutral-500 truncate max-w-[320px]">from {x}</div>)}</td>
      <td className="px-4 py-3 text-xs">{r.hits}×</td>
      <td className="px-4 py-3 text-xs whitespace-nowrap">{day(r.last_at)}</td>
      <td className="px-4 py-3"><div className="flex gap-2 min-w-[300px]">
        <input value={to} onChange={(e) => setTo(e.target.value)} placeholder="Send visitors to, e.g. /collections/rings" className="flex-1 border border-neutral-300 px-3 py-2 text-xs" data-testid={`broken-to-${r.id}`} />
        <Btn onClick={fix} disabled={!to.trim()} data-testid={`broken-fix-${r.id}`}>Redirect</Btn>
        <Btn ghost onClick={dismiss} data-testid={`broken-dismiss-${r.id}`}>Dismiss</Btn>
      </div></td>
    </tr>
  );
}

export function BrokenLinks() {
  const [items, setItems] = useState<any[] | null>(null);
  const load = () => api.get("/admin-x/seo/not-found").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const clear = async () => { if (window.confirm("Clear the whole broken link list?")) { await api.delete("/admin-x/seo/not-found"); load(); } };
  return (
    <div className="space-y-5" data-testid="broken-links">
      <div className="flex flex-wrap items-center gap-3">
        <p className="text-sm text-neutral-600 max-w-2xl">Addresses visitors tried that don't exist — often old links from Google, Instagram or emails. Point each one to the right page, or dismiss it.</p>
        {!!items?.length && <Btn ghost onClick={clear} className="ml-auto" data-testid="broken-clear">Clear list</Btn>}
      </div>
      <Table head={["Address", "Visits", "Last seen", "Fix"]} testId="broken-table">{(items || []).map((r) => <Row key={r.id} r={r} onDone={load} />)}</Table>
      {items && !items.length && <p className="text-sm text-neutral-500" data-testid="broken-empty">No broken links found yet. Every missed address will appear here.</p>}
    </div>
  );
}
